import {sameCanonicalJson, type ApprovedWritingGuideRelease} from '../../vendor/src/features/remotion-editor/editor/items/code/approved-writing-guide-release';

// Generated from the four RESTORED company bundles. All file roles, paths,
// hashes and byte lengths are pinned so a project-provided manifest cannot
// authorize its own renderer or runtime. The manifest hash pins fetched bytes.
export type PinnedWritingBundle = {
  manifest: Record<string, unknown>;
  manifestByteLength: number;
  manifestSha256: string;
};

const PINNED: PinnedWritingBundle[] = [
  {
    "manifest": {
      "alphabetCase": "lowercase",
      "bundleContentHash": "sha256:4848468e3fc5bf5a206c05001bc437ca5d43347947dfe42cf84a315f1516e47a",
      "files": {
        "approvalBinding": {
          "byteLength": 630,
          "path": "validation/approval-binding.json",
          "sha256": "sha256:9c09a3ae0540006f8dd408d6e51e2dcd1608bc63e42eea18a34fca00ab7a4a27"
        },
        "approvalReferenceManifest": {
          "byteLength": 1130,
          "path": "validation/approval-reference.json",
          "sha256": "sha256:fa98ed49331301576c91156c42cf46ce922feb813c710897823eee892f70c400"
        },
        "approvalState": {
          "byteLength": 370047,
          "path": "approval-state.json",
          "sha256": "sha256:fb0a51696337c69b7c9b60c7a3419d61e6282d61946d2ac51e5aadb640e7cd61"
        },
        "cutModelReference": {
          "byteLength": 44913,
          "path": "authoring/reference/cut-model.js",
          "sha256": "sha256:cf8847105dfbbd3f69163b5ff5535dafd448e95e3346afbfab5c4944b415f108"
        },
        "frameEvidenceFramesE0125Png": {
          "byteLength": 31897,
          "path": "validation/evidence/frames/e-0125.png",
          "sha256": "sha256:bfb24bb90ac30eb01722fe010467aae6f9e052b3e767ea778d9297e3abdee74c"
        },
        "frameEvidenceFramesE0250Png": {
          "byteLength": 31876,
          "path": "validation/evidence/frames/e-0250.png",
          "sha256": "sha256:3e75e686927d66ec3f8864788472169e85ee0d1e665d0c240bb919c4db7959d5"
        },
        "frameEvidenceFramesE0500Png": {
          "byteLength": 31641,
          "path": "validation/evidence/frames/e-0500.png",
          "sha256": "sha256:4be2472d1fb8d16599e1ac2265de379cb221230eabd5953f4079be608f8deaa3"
        },
        "frameEvidenceFramesE0750Png": {
          "byteLength": 31946,
          "path": "validation/evidence/frames/e-0750.png",
          "sha256": "sha256:baf06b7be9f01522412db05e37a374efab6348604dc01cfa98482e0ca3fc8f2a"
        },
        "frameEvidenceFramesE1000Png": {
          "byteLength": 31686,
          "path": "validation/evidence/frames/e-1000.png",
          "sha256": "sha256:57d5db516880df460c3db69206db448327edc41a949b277bd4a6a12c58b36260"
        },
        "frameEvidenceFramesG0125Png": {
          "byteLength": 36796,
          "path": "validation/evidence/frames/g-0125.png",
          "sha256": "sha256:42bbdddccd857d49f9112f0c005bbb8cdc2c2d79c5d65c984e5576154584f8e1"
        },
        "frameEvidenceFramesG0250Png": {
          "byteLength": 36890,
          "path": "validation/evidence/frames/g-0250.png",
          "sha256": "sha256:eec05be961b6df279a6577a1d46fb22a3baff05f6383decaf3eb3ef57dad4d63"
        },
        "frameEvidenceFramesG0500Png": {
          "byteLength": 36406,
          "path": "validation/evidence/frames/g-0500.png",
          "sha256": "sha256:43a4c7dfafd25f2a2c19d4ed6447f7e433a3e534a35e015472cd17921c194319"
        },
        "frameEvidenceFramesG0750Png": {
          "byteLength": 35739,
          "path": "validation/evidence/frames/g-0750.png",
          "sha256": "sha256:bfebccf25d35371168576136ac0c280832bd0a63fd3a0f22d9b8755a10c00f56"
        },
        "frameEvidenceFramesG1000Png": {
          "byteLength": 35140,
          "path": "validation/evidence/frames/g-1000.png",
          "sha256": "sha256:92a707b2f8cc53ec2e69dfc7e3d9b931b219a8f13abfd9d66e694358bb57afc4"
        },
        "frameEvidenceFramesO0125Png": {
          "byteLength": 31709,
          "path": "validation/evidence/frames/o-0125.png",
          "sha256": "sha256:7845020bb0635512eb0aa25ef7ffb2e71c59a6f8fe6d7596d6fafb609857b76d"
        },
        "frameEvidenceFramesO0250Png": {
          "byteLength": 31175,
          "path": "validation/evidence/frames/o-0250.png",
          "sha256": "sha256:6b9e29d6ac688da76eb68e79e0281af8be648147a9eb9c06f1a5a94257c3a8e2"
        },
        "frameEvidenceFramesO0500Png": {
          "byteLength": 30971,
          "path": "validation/evidence/frames/o-0500.png",
          "sha256": "sha256:87facea50413ac4dae342cd7062a947dd5eec6aeb16f2bf12ce414e3ff7b89ac"
        },
        "frameEvidenceFramesO0750Png": {
          "byteLength": 30972,
          "path": "validation/evidence/frames/o-0750.png",
          "sha256": "sha256:c1eae3a5885213905698b93097a16b9a4fb54b0e6b1705712d23da99d9e4407b"
        },
        "frameEvidenceFramesO1000Png": {
          "byteLength": 30414,
          "path": "validation/evidence/frames/o-1000.png",
          "sha256": "sha256:52b7e11bad40f53f41ae9da727ace472159bcec4750f825c73f14bfe76179f6d"
        },
        "frameEvidenceFramesY0125Png": {
          "byteLength": 32446,
          "path": "validation/evidence/frames/y-0125.png",
          "sha256": "sha256:6e1f7d0966aeb5deb31d06c1e754bce8f47e4f8f695182f521274a11eedca9ec"
        },
        "frameEvidenceFramesY0250Png": {
          "byteLength": 32283,
          "path": "validation/evidence/frames/y-0250.png",
          "sha256": "sha256:2bd71a12ff9e9b7a891f247c644d8ba64c4a521ccadebe5d06bbf3c38f1f471a"
        },
        "frameEvidenceFramesY0500Png": {
          "byteLength": 32073,
          "path": "validation/evidence/frames/y-0500.png",
          "sha256": "sha256:eb3bf7b96ef3e6967852fa54243271637cae690ad68e87f49992985d55a3beb3"
        },
        "frameEvidenceFramesY0750Png": {
          "byteLength": 31875,
          "path": "validation/evidence/frames/y-0750.png",
          "sha256": "sha256:ecda0a0d99d14731e215ae0418469194b9a8a3a2fde7aab288301121322c51b5"
        },
        "frameEvidenceFramesY1000Png": {
          "byteLength": 31489,
          "path": "validation/evidence/frames/y-1000.png",
          "sha256": "sha256:734f3b4ac128f3f3d47ea902dd316fda6c5c54bec0f2445eb7ba163ad5bb6cc1"
        },
        "frameEvidenceManifest": {
          "byteLength": 8220,
          "path": "validation/evidence/manifest.json",
          "sha256": "sha256:0d78e9151cf514e10d7a6a5f15d517b70b3b24da443587eed5334f26f8cffbac"
        },
        "frameEvidenceREADMEMd": {
          "byteLength": 1140,
          "path": "validation/evidence/README.md",
          "sha256": "sha256:6f3544f40fcc4f225fa64484100c8b3c490b52981e7093bebcf99eb47ac2a6cb"
        },
        "guideAsset": {
          "byteLength": 172451,
          "path": "authoring/reference/guide-assets.js",
          "sha256": "sha256:b97ecd806cb66d37687111f2159934dc8915ec43ebcbb973e22c94a45dc6ae2a"
        },
        "guideAssetJson": {
          "byteLength": 171898,
          "path": "assets/alphabet-guides/generated/lowercase-guide-assets.v1.json",
          "sha256": "sha256:1fbc98259e8862e4dd330b49b435d4a3e267a4d8aa036dca99ecd692b3a51d21"
        },
        "originalSvgA": {
          "byteLength": 5484,
          "path": "assets/alphabet-guides/lowercase-svg/a.svg",
          "sha256": "sha256:e4f4095a352d41ca6d8d570a4ddeabe73b932bb086b712b807ceb6efd1d84e03"
        },
        "originalSvgB": {
          "byteLength": 5420,
          "path": "assets/alphabet-guides/lowercase-svg/b.svg",
          "sha256": "sha256:db868ade62882d24575674758b5f898f0e94f7e407dec80e342a37cecaad6d54"
        },
        "originalSvgC": {
          "byteLength": 4986,
          "path": "assets/alphabet-guides/lowercase-svg/c.svg",
          "sha256": "sha256:00cd47f75be5204e8452d85c1c157254e95bd26b93266beec9fa331d278990fa"
        },
        "originalSvgD": {
          "byteLength": 5394,
          "path": "assets/alphabet-guides/lowercase-svg/d.svg",
          "sha256": "sha256:e8674d318bc881c6092f0fbd1da4f804bdf08f66329c9b23c5bf85a24075993d"
        },
        "originalSvgE": {
          "byteLength": 5720,
          "path": "assets/alphabet-guides/lowercase-svg/e.svg",
          "sha256": "sha256:18b5313a3cb9d3143506e45716d2b2d247d9340626e5aa2bac37328992c64600"
        },
        "originalSvgF": {
          "byteLength": 4908,
          "path": "assets/alphabet-guides/lowercase-svg/f.svg",
          "sha256": "sha256:864589f19e4839269dd7d05da58e0842b201c6cd09fc904ad570f90593d7e3bf"
        },
        "originalSvgG": {
          "byteLength": 6682,
          "path": "assets/alphabet-guides/lowercase-svg/g.svg",
          "sha256": "sha256:710ef27c31a96b578b15f4ccf989a4930ebb5a1afea234aad8e44ef2551d4e38"
        },
        "originalSvgH": {
          "byteLength": 4727,
          "path": "assets/alphabet-guides/lowercase-svg/h.svg",
          "sha256": "sha256:2ca8122b04853f4bd86d5c88f2bbbe944219e3444d82f9b7f5865dcf6879a983"
        },
        "originalSvgI": {
          "byteLength": 4102,
          "path": "assets/alphabet-guides/lowercase-svg/i.svg",
          "sha256": "sha256:b6062063c5185efd495e76caad8f146f3d5d4977d9390af3f57c868185cf104b"
        },
        "originalSvgJ": {
          "byteLength": 4581,
          "path": "assets/alphabet-guides/lowercase-svg/j.svg",
          "sha256": "sha256:2d566bcef4bafe64bbecf5fa84185032fe8cedaec6472815e0a0fca5088ac8f6"
        },
        "originalSvgK": {
          "byteLength": 5436,
          "path": "assets/alphabet-guides/lowercase-svg/k.svg",
          "sha256": "sha256:f4cb3a00e0616a859d9445e040750161c935ea1c7017cf57423fac3268341bf3"
        },
        "originalSvgL": {
          "byteLength": 3115,
          "path": "assets/alphabet-guides/lowercase-svg/l.svg",
          "sha256": "sha256:cd82bff595d3c67d23f684f88eb52287dd531eec24ac36b59b18ef3d0e92ce52"
        },
        "originalSvgM": {
          "byteLength": 7457,
          "path": "assets/alphabet-guides/lowercase-svg/m.svg",
          "sha256": "sha256:e762e33d767709e9aef15b6f8e61bd4c398d3ee8733b4fee71f5458fb04ee756"
        },
        "originalSvgN": {
          "byteLength": 5139,
          "path": "assets/alphabet-guides/lowercase-svg/n.svg",
          "sha256": "sha256:a8859c03fc04107a0099400c388e966fd6d1e00cf9b8d611ac31d886707b801f"
        },
        "originalSvgO": {
          "byteLength": 3958,
          "path": "assets/alphabet-guides/lowercase-svg/o.svg",
          "sha256": "sha256:7050d03e7a09985cdb66b2d1f118fa09ec827d68896a9dacb35be00d527e6afb"
        },
        "originalSvgP": {
          "byteLength": 5442,
          "path": "assets/alphabet-guides/lowercase-svg/p.svg",
          "sha256": "sha256:898af6055b8b541fa27a6dcaaff349e202f3578300a751349c614042b0a44000"
        },
        "originalSvgQ": {
          "byteLength": 5566,
          "path": "assets/alphabet-guides/lowercase-svg/q.svg",
          "sha256": "sha256:90966e0c2f3520f25f8d85f6676eb886c6c24e2d3f4098760c866378b8f1c12c"
        },
        "originalSvgR": {
          "byteLength": 4742,
          "path": "assets/alphabet-guides/lowercase-svg/r.svg",
          "sha256": "sha256:b9a221edf56c8a773e548326fe98fdd74250c8b7455e8ff36c6196f21416ec57"
        },
        "originalSvgS": {
          "byteLength": 6143,
          "path": "assets/alphabet-guides/lowercase-svg/s.svg",
          "sha256": "sha256:7359baee9ac4e8c7ba16bb0a29d5bfcb6ccb58079a318c890b5c18c374b8f870"
        },
        "originalSvgT": {
          "byteLength": 4936,
          "path": "assets/alphabet-guides/lowercase-svg/t.svg",
          "sha256": "sha256:b760d35406516af7c0b939c348190a822c70fd25d7588724a721bab5188722c2"
        },
        "originalSvgU": {
          "byteLength": 5108,
          "path": "assets/alphabet-guides/lowercase-svg/u.svg",
          "sha256": "sha256:19396206adea7358bbf5f518a165e2da6e6783ddf01af6f22cb1ddb6cfa7e8f6"
        },
        "originalSvgV": {
          "byteLength": 3562,
          "path": "assets/alphabet-guides/lowercase-svg/v.svg",
          "sha256": "sha256:76f444d00347a3649f3c521b2419da3ae8b3bd1736d2291f05b8fc1430718e23"
        },
        "originalSvgW": {
          "byteLength": 6732,
          "path": "assets/alphabet-guides/lowercase-svg/w.svg",
          "sha256": "sha256:e123121aafffbacb7a1cb8b9b31812ee5520c2fbecdb5c24f3181993d525b62e"
        },
        "originalSvgX": {
          "byteLength": 4847,
          "path": "assets/alphabet-guides/lowercase-svg/x.svg",
          "sha256": "sha256:5ee59887c7771f1b8d20e08c345bcd93c9e1321cdae7c1311d28237b567edfb3"
        },
        "originalSvgY": {
          "byteLength": 3715,
          "path": "assets/alphabet-guides/lowercase-svg/y.svg",
          "sha256": "sha256:6d44a7be675a42e0f7b6ecbdddb192b555fc5177f83a23e6ee0c86887422f6d0"
        },
        "originalSvgZ": {
          "byteLength": 4958,
          "path": "assets/alphabet-guides/lowercase-svg/z.svg",
          "sha256": "sha256:9464874c3cc2ce5dec5c7e6e418b4b9de207e8418c878e79de12821a00a2ac1d"
        },
        "renderer": {
          "byteLength": 113577,
          "path": "renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "rendererReference": {
          "byteLength": 113577,
          "path": "authoring/reference/renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "runtime": {
          "byteLength": 712504,
          "path": "runtime.json",
          "sha256": "sha256:d72190e5d42c09fa51b77e33791b566cff62a225b21d83f0f8d96d3ece7afe5f"
        },
        "sandboxReference": {
          "byteLength": 407568,
          "path": "authoring/reference/sandbox.html",
          "sha256": "sha256:5f44841b5286eed7d0108c990dd82ee8f03c1bda7252219cb9b210374c1c165d"
        },
        "sourceManifest": {
          "byteLength": 7922,
          "path": "assets/alphabet-guides/manifests/lowercase-source-manifest.v1.json",
          "sha256": "sha256:4b2502cad013b9e5fb65c0a14905915c0d9ed3ab92c118bb4cd7c6a1151f4b2c"
        },
        "validationReport": {
          "byteLength": 45325,
          "path": "validation/frame-report.json",
          "sha256": "sha256:a2792e9ca22f979b0ba1844e5313c615494f35103d8789cb63ce3839c225b8cb"
        },
        "visualValidation": {
          "byteLength": 24037,
          "path": "validation/visual-controls.json",
          "sha256": "sha256:12ce740839a42d342a4946cb18a041a20f7e1cf53f55677f7018fc279f37ddde"
        },
        "wordLayoutPolicy": {
          "byteLength": 122,
          "path": "word-layout-policy.json",
          "sha256": "sha256:be52abc601e8237054954cfe51d2963c066d8e55c5047faed8d5db8ae02bf4bc"
        }
      },
      "glyphs": "abcdefghijklmnopqrstuvwxyz",
      "playbackContract": "authoringStrokePlayback",
      "profiles": {
        "aiRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ],
        "audit": [
          "approvalBinding",
          "approvalReferenceManifest",
          "approvalState",
          "cutModelReference",
          "frameEvidenceFramesE0125Png",
          "frameEvidenceFramesE0250Png",
          "frameEvidenceFramesE0500Png",
          "frameEvidenceFramesE0750Png",
          "frameEvidenceFramesE1000Png",
          "frameEvidenceFramesG0125Png",
          "frameEvidenceFramesG0250Png",
          "frameEvidenceFramesG0500Png",
          "frameEvidenceFramesG0750Png",
          "frameEvidenceFramesG1000Png",
          "frameEvidenceFramesO0125Png",
          "frameEvidenceFramesO0250Png",
          "frameEvidenceFramesO0500Png",
          "frameEvidenceFramesO0750Png",
          "frameEvidenceFramesO1000Png",
          "frameEvidenceFramesY0125Png",
          "frameEvidenceFramesY0250Png",
          "frameEvidenceFramesY0500Png",
          "frameEvidenceFramesY0750Png",
          "frameEvidenceFramesY1000Png",
          "frameEvidenceManifest",
          "frameEvidenceREADMEMd",
          "guideAsset",
          "guideAssetJson",
          "originalSvgA",
          "originalSvgB",
          "originalSvgC",
          "originalSvgD",
          "originalSvgE",
          "originalSvgF",
          "originalSvgG",
          "originalSvgH",
          "originalSvgI",
          "originalSvgJ",
          "originalSvgK",
          "originalSvgL",
          "originalSvgM",
          "originalSvgN",
          "originalSvgO",
          "originalSvgP",
          "originalSvgQ",
          "originalSvgR",
          "originalSvgS",
          "originalSvgT",
          "originalSvgU",
          "originalSvgV",
          "originalSvgW",
          "originalSvgX",
          "originalSvgY",
          "originalSvgZ",
          "renderer",
          "rendererReference",
          "runtime",
          "sandboxReference",
          "sourceManifest",
          "validationReport",
          "visualValidation",
          "wordLayoutPolicy"
        ],
        "webRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ]
      },
      "projectBindingVersion": "alphabet.authoring_project_binding.v2",
      "releaseId": "lowercase-bundle-4848468e3fc5bf5a",
      "rendererVersion": "alphabet.authoring_playback_engine.v4",
      "runtimeVersion": "alphabet.authoring_runtime.v2",
      "validation": {
        "comparison": "green-fill-mask-pixel-exact",
        "frameCount": 130,
        "status": "passed"
      },
      "version": "alphabet.authoring_release_bundle.v1"
    },
    "manifestByteLength": 15416,
    "manifestSha256": "sha256:80f232324bc0f654d34c9c774cf4b6444332a55139a308c309a98323153d98a0"
  },
  {
    "manifest": {
      "alphabetCase": "uppercase",
      "bundleContentHash": "sha256:735c415845b4794c59544b9d043dab8493a8060233725057dadf04d7f5a0b1ac",
      "files": {
        "approvalBinding": {
          "byteLength": 630,
          "path": "validation/approval-binding.json",
          "sha256": "sha256:2fcfe2b5f48d610b4bc3a9e48202f69ec08d13ed41cc8994d364e7ec4bf373b4"
        },
        "approvalReferenceManifest": {
          "byteLength": 1130,
          "path": "validation/approval-reference.json",
          "sha256": "sha256:f88e396f383fde8b91778365d7ca0658d4c91134756dfcbf12fdde84c191c60e"
        },
        "approvalState": {
          "byteLength": 475355,
          "path": "approval-state.json",
          "sha256": "sha256:ec796c5f70d761cbe0d69715869750b2c76c3dae89cf373f6f9fe5e6c8309381"
        },
        "cutModelReference": {
          "byteLength": 44913,
          "path": "authoring/reference/cut-model.js",
          "sha256": "sha256:cf8847105dfbbd3f69163b5ff5535dafd448e95e3346afbfab5c4944b415f108"
        },
        "frameEvidenceFramesA0125Png": {
          "byteLength": 36223,
          "path": "validation/evidence/frames/A-0125.png",
          "sha256": "sha256:2c67ab33829ee1f6efdd85c24717c567655a9dad2643fb6b0c8473412aef9313"
        },
        "frameEvidenceFramesA0250Png": {
          "byteLength": 36030,
          "path": "validation/evidence/frames/A-0250.png",
          "sha256": "sha256:ffd836d42cc5e0a6444d2aaecfa1a99e08f0916526d7a35de13efed1628af695"
        },
        "frameEvidenceFramesA0500Png": {
          "byteLength": 35260,
          "path": "validation/evidence/frames/A-0500.png",
          "sha256": "sha256:669db62c04c45c62615cbdcaa2517d247f8206046db6c41e2a99bea68fde84f3"
        },
        "frameEvidenceFramesA0750Png": {
          "byteLength": 34531,
          "path": "validation/evidence/frames/A-0750.png",
          "sha256": "sha256:63f19932bb852c399469b85e670c9d7df9e53fb3b321aead24c4b323dd880c17"
        },
        "frameEvidenceFramesA1000Png": {
          "byteLength": 34202,
          "path": "validation/evidence/frames/A-1000.png",
          "sha256": "sha256:5f60d5611b0ea6ecf6f7b32cced07b0d310185e42e73c2d4fe9714ea62b959f2"
        },
        "frameEvidenceFramesB0125Png": {
          "byteLength": 32700,
          "path": "validation/evidence/frames/B-0125.png",
          "sha256": "sha256:3e9e04bca37e03ca733a5b69a3e600341f81f1655d29cf6c6c54313c436d7bd4"
        },
        "frameEvidenceFramesB0250Png": {
          "byteLength": 32171,
          "path": "validation/evidence/frames/B-0250.png",
          "sha256": "sha256:4ebdf6a964fdd8e8b827c9ef4a63f6ab3320eae56f55d79c64fce468e0de002e"
        },
        "frameEvidenceFramesB0500Png": {
          "byteLength": 31581,
          "path": "validation/evidence/frames/B-0500.png",
          "sha256": "sha256:40a2825fab3de567d3798d7838828e241472f41d4c32ad1af9dcf422c22ecb08"
        },
        "frameEvidenceFramesB0750Png": {
          "byteLength": 31164,
          "path": "validation/evidence/frames/B-0750.png",
          "sha256": "sha256:be4450d0005e999943bb5c4afab68f5796faf8d1b750eafee3e4498ba79adca1"
        },
        "frameEvidenceFramesB1000Png": {
          "byteLength": 30975,
          "path": "validation/evidence/frames/B-1000.png",
          "sha256": "sha256:458dbfb1d5538cca2f34228449d42d524fd674c0f07e0ece0148244dbe0420bd"
        },
        "frameEvidenceFramesG0125Png": {
          "byteLength": 39285,
          "path": "validation/evidence/frames/G-0125.png",
          "sha256": "sha256:2889a399d879a6b6d5f93e35d6856045b2456a8798a4adade90304eca6f7081f"
        },
        "frameEvidenceFramesG0250Png": {
          "byteLength": 39287,
          "path": "validation/evidence/frames/G-0250.png",
          "sha256": "sha256:41fc19febc35011e063fe2691762e7270a124fa43db1014341e671e7c9c412e7"
        },
        "frameEvidenceFramesG0500Png": {
          "byteLength": 39517,
          "path": "validation/evidence/frames/G-0500.png",
          "sha256": "sha256:c305c02377712ea88a14c4a749463d446b1d4c5f6a90d2e3ac61f9dc80eb78f7"
        },
        "frameEvidenceFramesG0750Png": {
          "byteLength": 39574,
          "path": "validation/evidence/frames/G-0750.png",
          "sha256": "sha256:9a72e5948d7765e2d83de1e4aadeb078118302e30297f2e9e3e34beb1e0c3055"
        },
        "frameEvidenceFramesG1000Png": {
          "byteLength": 39253,
          "path": "validation/evidence/frames/G-1000.png",
          "sha256": "sha256:53173c098a8274f1f7e54eccfb322a62c4c9fd124a891a29148ad0df66e5099b"
        },
        "frameEvidenceFramesO0125Png": {
          "byteLength": 42910,
          "path": "validation/evidence/frames/O-0125.png",
          "sha256": "sha256:7e1a075d13c9ff71fe464f0e36c0d5a266936b2f85f27a3246a733b055a9a3ea"
        },
        "frameEvidenceFramesO0250Png": {
          "byteLength": 42507,
          "path": "validation/evidence/frames/O-0250.png",
          "sha256": "sha256:e7ef5917044e7af493c4576589c6619b3165d94e7c0ad196cfba2bf9499c82c5"
        },
        "frameEvidenceFramesO0500Png": {
          "byteLength": 41972,
          "path": "validation/evidence/frames/O-0500.png",
          "sha256": "sha256:3da886a8542038f2a341b00afaf4b857037739f952ec46ec3a0b855d80dd3c0e"
        },
        "frameEvidenceFramesO0750Png": {
          "byteLength": 41056,
          "path": "validation/evidence/frames/O-0750.png",
          "sha256": "sha256:e18269b1af6ec1fa0ec5e91d78126f38b6a20ef27d46c2fb05047c3369bfdc88"
        },
        "frameEvidenceFramesO1000Png": {
          "byteLength": 40288,
          "path": "validation/evidence/frames/O-1000.png",
          "sha256": "sha256:506bd335335f2b8ab677bc8f720729a68e0c04471dae6b623adc1a7d53acc9ce"
        },
        "frameEvidenceManifest": {
          "byteLength": 8220,
          "path": "validation/evidence/manifest.json",
          "sha256": "sha256:944c4dacbc142e58c80a838afda76023cf72bdb3f3107beb8a1ed9e085d18e25"
        },
        "frameEvidenceREADMEMd": {
          "byteLength": 1140,
          "path": "validation/evidence/README.md",
          "sha256": "sha256:4000bfcacdd44dfe63c715416ff83c6a5fbe532e4d2d3e20578a9572e0a09a20"
        },
        "guideAsset": {
          "byteLength": 168593,
          "path": "authoring/reference/guide-assets.js",
          "sha256": "sha256:79f034d7d706788689321b4470339bb469dfeb54131374a17bbe4f18d2a89bf7"
        },
        "guideAssetJson": {
          "byteLength": 167980,
          "path": "assets/alphabet-guides/generated/uppercase-guide-assets.v1.json",
          "sha256": "sha256:3c026a449c1ce4f599e1a4c0cc9c707e21d2fbd3b3efc03acca482c95cea6d6b"
        },
        "originalSvgA": {
          "byteLength": 4921,
          "path": "assets/alphabet-guides/uppercase-svg/A.svg",
          "sha256": "sha256:ea297a67cc3b3ab43d9f1de36ce564b35bdb946edd3c23a19e7c1bbf4c77e01a"
        },
        "originalSvgB": {
          "byteLength": 6727,
          "path": "assets/alphabet-guides/uppercase-svg/B.svg",
          "sha256": "sha256:020c01bdd098be84214c01fd8233735dadac0b82c10bb27e12af96e2705aa7bd"
        },
        "originalSvgC": {
          "byteLength": 5622,
          "path": "assets/alphabet-guides/uppercase-svg/C.svg",
          "sha256": "sha256:bd4d565b0540f80a1b8fb567eede0c2a65834b88bf5dbc1ade8d81767815a668"
        },
        "originalSvgD": {
          "byteLength": 4299,
          "path": "assets/alphabet-guides/uppercase-svg/D.svg",
          "sha256": "sha256:e3f792f3d52c9daf7c7fb74252029c4dd702a2c95cca3462d0fa402d8866f367"
        },
        "originalSvgE": {
          "byteLength": 6086,
          "path": "assets/alphabet-guides/uppercase-svg/E.svg",
          "sha256": "sha256:a0c7ce87582276688a0ce64117d24957e38922f0a7cd821f08b5254acadfd673"
        },
        "originalSvgF": {
          "byteLength": 5004,
          "path": "assets/alphabet-guides/uppercase-svg/F.svg",
          "sha256": "sha256:dc1949ae89fa35214140b324a934bac22a4bb5df2e89d320ec2834d3aac84e9b"
        },
        "originalSvgG": {
          "byteLength": 6401,
          "path": "assets/alphabet-guides/uppercase-svg/G.svg",
          "sha256": "sha256:75ab3bf243d6fc7b32958a5d56c33acb6c31f239e5b48df4b2e3d673240be55b"
        },
        "originalSvgH": {
          "byteLength": 5354,
          "path": "assets/alphabet-guides/uppercase-svg/H.svg",
          "sha256": "sha256:74ab6ea8ece6a55d9c8e7089d194a9efc160a08d6857426ea56613b9aeb92b8f"
        },
        "originalSvgI": {
          "byteLength": 2396,
          "path": "assets/alphabet-guides/uppercase-svg/I.svg",
          "sha256": "sha256:49c3149b8803f32af9dc93c6c1e33b936680fa4742153732faf35df693b7bf92"
        },
        "originalSvgJ": {
          "byteLength": 3986,
          "path": "assets/alphabet-guides/uppercase-svg/J.svg",
          "sha256": "sha256:0e6974b8385d3489286c795b291502862e95f4e2e859921bde67d4faa20a9e66"
        },
        "originalSvgK": {
          "byteLength": 5440,
          "path": "assets/alphabet-guides/uppercase-svg/K.svg",
          "sha256": "sha256:9d945e355be95adc42729315bec571a46137436dc2c72ac23ae6925940b21bb5"
        },
        "originalSvgL": {
          "byteLength": 3502,
          "path": "assets/alphabet-guides/uppercase-svg/L.svg",
          "sha256": "sha256:229a54c80555d24d1783ba55cb3aaedb7e088252c0ed4d415165af239bc861ae"
        },
        "originalSvgM": {
          "byteLength": 6741,
          "path": "assets/alphabet-guides/uppercase-svg/M.svg",
          "sha256": "sha256:7148abaf0eb7f8eae1a47554748b94125c75680b11fdfb4db08466f882daf18f"
        },
        "originalSvgN": {
          "byteLength": 5234,
          "path": "assets/alphabet-guides/uppercase-svg/N.svg",
          "sha256": "sha256:fc06c3146b920839448aa312f23669f5791baca91b4ae7dc9a7564f781062072"
        },
        "originalSvgO": {
          "byteLength": 4450,
          "path": "assets/alphabet-guides/uppercase-svg/O.svg",
          "sha256": "sha256:161660cfbe27b35cf33cc8e909d322861eb210359ab1052c0a8797b88d55b585"
        },
        "originalSvgP": {
          "byteLength": 4450,
          "path": "assets/alphabet-guides/uppercase-svg/P.svg",
          "sha256": "sha256:263665875c3314203849c125b7afd8fdeb9822ba72d3ccec06bad3aa82151bc4"
        },
        "originalSvgQ": {
          "byteLength": 5947,
          "path": "assets/alphabet-guides/uppercase-svg/Q.svg",
          "sha256": "sha256:b4e95088ad6a3944a8e857ba9bc80a0703f59d4eef09620d9753fd670296e36b"
        },
        "originalSvgR": {
          "byteLength": 6064,
          "path": "assets/alphabet-guides/uppercase-svg/R.svg",
          "sha256": "sha256:474038d3bdba9606570ad03332023102ee6110998cf91b66c5707a742d882eb4"
        },
        "originalSvgS": {
          "byteLength": 6603,
          "path": "assets/alphabet-guides/uppercase-svg/S.svg",
          "sha256": "sha256:bf85858b4148f58d2d136b09f19ee280e7ef2e40f9a2445ef6a589fe73647ca1"
        },
        "originalSvgT": {
          "byteLength": 3758,
          "path": "assets/alphabet-guides/uppercase-svg/T.svg",
          "sha256": "sha256:17ee832c68f3a57be468a354cf88186fde8a39e58005c3dd99f546b2dddc3bd4"
        },
        "originalSvgU": {
          "byteLength": 3821,
          "path": "assets/alphabet-guides/uppercase-svg/U.svg",
          "sha256": "sha256:e19256a3be8997f6fbdcefea3b0f8d7bffec1608549d71325074d85594048485"
        },
        "originalSvgV": {
          "byteLength": 3616,
          "path": "assets/alphabet-guides/uppercase-svg/V.svg",
          "sha256": "sha256:a0b188444bddb8faa3b3638ad784b8f41f664120ed03991669da70c62c601630"
        },
        "originalSvgW": {
          "byteLength": 6930,
          "path": "assets/alphabet-guides/uppercase-svg/W.svg",
          "sha256": "sha256:e0bca49d0405372380e200f51335527608c8986efc760618c4f5c132410b0cd8"
        },
        "originalSvgX": {
          "byteLength": 4546,
          "path": "assets/alphabet-guides/uppercase-svg/X.svg",
          "sha256": "sha256:01005f82f06890974c7057f0984cc7cb98001a305ad987530d1e63bc58ed34ad"
        },
        "originalSvgY": {
          "byteLength": 4893,
          "path": "assets/alphabet-guides/uppercase-svg/Y.svg",
          "sha256": "sha256:eeda66413eb6002b22e23eb5f2b772a4e1daa2a9217bc0ffb27e33abf9915fb9"
        },
        "originalSvgZ": {
          "byteLength": 5049,
          "path": "assets/alphabet-guides/uppercase-svg/Z.svg",
          "sha256": "sha256:eeb12914e873a3992ee8f99bf5d80cfedd3a9a015e4a0680b80723e28cdcf949"
        },
        "renderer": {
          "byteLength": 113577,
          "path": "renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "rendererReference": {
          "byteLength": 113577,
          "path": "authoring/reference/renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "runtime": {
          "byteLength": 985989,
          "path": "runtime.json",
          "sha256": "sha256:2e6af7df767bfdca58b2775404ec40f11535e7927aa42c022fdcd3d4f4634bce"
        },
        "sandboxReference": {
          "byteLength": 407568,
          "path": "authoring/reference/sandbox.html",
          "sha256": "sha256:5f44841b5286eed7d0108c990dd82ee8f03c1bda7252219cb9b210374c1c165d"
        },
        "sourceManifest": {
          "byteLength": 7952,
          "path": "assets/alphabet-guides/manifests/uppercase-source-manifest.v1.json",
          "sha256": "sha256:733cc740649e740ffaaa29cf852b01d63acc6c3080e658cd397aed6a65513b18"
        },
        "validationReport": {
          "byteLength": 45370,
          "path": "validation/frame-report.json",
          "sha256": "sha256:9dce577df989ee12f12b0f3f4e525743d8fad54ca3bce47f66a58ae6a9271cd2"
        },
        "visualValidation": {
          "byteLength": 25129,
          "path": "validation/visual-controls.json",
          "sha256": "sha256:0d4633a5d705bf24b7b21c33d70bb33e87223289e00ba8746c954d9bf8ab190b"
        },
        "wordLayoutPolicy": {
          "byteLength": 122,
          "path": "word-layout-policy.json",
          "sha256": "sha256:be52abc601e8237054954cfe51d2963c066d8e55c5047faed8d5db8ae02bf4bc"
        }
      },
      "glyphs": "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      "playbackContract": "authoringStrokePlayback",
      "profiles": {
        "aiRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ],
        "audit": [
          "approvalBinding",
          "approvalReferenceManifest",
          "approvalState",
          "cutModelReference",
          "frameEvidenceFramesA0125Png",
          "frameEvidenceFramesA0250Png",
          "frameEvidenceFramesA0500Png",
          "frameEvidenceFramesA0750Png",
          "frameEvidenceFramesA1000Png",
          "frameEvidenceFramesB0125Png",
          "frameEvidenceFramesB0250Png",
          "frameEvidenceFramesB0500Png",
          "frameEvidenceFramesB0750Png",
          "frameEvidenceFramesB1000Png",
          "frameEvidenceFramesG0125Png",
          "frameEvidenceFramesG0250Png",
          "frameEvidenceFramesG0500Png",
          "frameEvidenceFramesG0750Png",
          "frameEvidenceFramesG1000Png",
          "frameEvidenceFramesO0125Png",
          "frameEvidenceFramesO0250Png",
          "frameEvidenceFramesO0500Png",
          "frameEvidenceFramesO0750Png",
          "frameEvidenceFramesO1000Png",
          "frameEvidenceManifest",
          "frameEvidenceREADMEMd",
          "guideAsset",
          "guideAssetJson",
          "originalSvgA",
          "originalSvgB",
          "originalSvgC",
          "originalSvgD",
          "originalSvgE",
          "originalSvgF",
          "originalSvgG",
          "originalSvgH",
          "originalSvgI",
          "originalSvgJ",
          "originalSvgK",
          "originalSvgL",
          "originalSvgM",
          "originalSvgN",
          "originalSvgO",
          "originalSvgP",
          "originalSvgQ",
          "originalSvgR",
          "originalSvgS",
          "originalSvgT",
          "originalSvgU",
          "originalSvgV",
          "originalSvgW",
          "originalSvgX",
          "originalSvgY",
          "originalSvgZ",
          "renderer",
          "rendererReference",
          "runtime",
          "sandboxReference",
          "sourceManifest",
          "validationReport",
          "visualValidation",
          "wordLayoutPolicy"
        ],
        "webRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ]
      },
      "projectBindingVersion": "alphabet.authoring_project_binding.v2",
      "releaseId": "uppercase-bundle-735c415845b4794c",
      "rendererVersion": "alphabet.authoring_playback_engine.v4",
      "runtimeVersion": "alphabet.authoring_runtime.v2",
      "validation": {
        "comparison": "green-fill-mask-pixel-exact",
        "frameCount": 130,
        "status": "passed"
      },
      "version": "alphabet.authoring_release_bundle.v1"
    },
    "manifestByteLength": 15416,
    "manifestSha256": "sha256:09c709d2c991ae79c03823629ba7f59d991bd5cfe29dca44e876f656388cdd27"
  },
  {
    "manifest": {
      "alphabetCase": "lowercase",
      "bundleContentHash": "sha256:981d633d17a3bc31586d7433b82ceb7e9903beccecdbef2b5c4cb52c2306641a",
      "files": {
        "approvalBinding": {
          "byteLength": 630,
          "path": "validation/approval-binding.json",
          "sha256": "sha256:2741629131cf35c489d5d292d0932a914a9153f6fdfc933ed64d129dc8c2bafa"
        },
        "approvalReferenceManifest": {
          "byteLength": 1130,
          "path": "validation/approval-reference.json",
          "sha256": "sha256:7c8938d112222591dd35940057591441936720d0e40a8292f1dbf649e718c673"
        },
        "approvalState": {
          "byteLength": 370047,
          "path": "approval-state.json",
          "sha256": "sha256:3368b6d7a706dedb9ee4a971cd38246d2b4768d0188a0ed69689f0f6be6bbdde"
        },
        "cutModelReference": {
          "byteLength": 44913,
          "path": "authoring/reference/cut-model.js",
          "sha256": "sha256:cf8847105dfbbd3f69163b5ff5535dafd448e95e3346afbfab5c4944b415f108"
        },
        "frameEvidenceFramesE0125Png": {
          "byteLength": 31897,
          "path": "validation/evidence/frames/e-0125.png",
          "sha256": "sha256:bfb24bb90ac30eb01722fe010467aae6f9e052b3e767ea778d9297e3abdee74c"
        },
        "frameEvidenceFramesE0250Png": {
          "byteLength": 31876,
          "path": "validation/evidence/frames/e-0250.png",
          "sha256": "sha256:3e75e686927d66ec3f8864788472169e85ee0d1e665d0c240bb919c4db7959d5"
        },
        "frameEvidenceFramesE0500Png": {
          "byteLength": 31641,
          "path": "validation/evidence/frames/e-0500.png",
          "sha256": "sha256:4be2472d1fb8d16599e1ac2265de379cb221230eabd5953f4079be608f8deaa3"
        },
        "frameEvidenceFramesE0750Png": {
          "byteLength": 31946,
          "path": "validation/evidence/frames/e-0750.png",
          "sha256": "sha256:baf06b7be9f01522412db05e37a374efab6348604dc01cfa98482e0ca3fc8f2a"
        },
        "frameEvidenceFramesE1000Png": {
          "byteLength": 31686,
          "path": "validation/evidence/frames/e-1000.png",
          "sha256": "sha256:57d5db516880df460c3db69206db448327edc41a949b277bd4a6a12c58b36260"
        },
        "frameEvidenceFramesG0125Png": {
          "byteLength": 36796,
          "path": "validation/evidence/frames/g-0125.png",
          "sha256": "sha256:42bbdddccd857d49f9112f0c005bbb8cdc2c2d79c5d65c984e5576154584f8e1"
        },
        "frameEvidenceFramesG0250Png": {
          "byteLength": 36890,
          "path": "validation/evidence/frames/g-0250.png",
          "sha256": "sha256:eec05be961b6df279a6577a1d46fb22a3baff05f6383decaf3eb3ef57dad4d63"
        },
        "frameEvidenceFramesG0500Png": {
          "byteLength": 36406,
          "path": "validation/evidence/frames/g-0500.png",
          "sha256": "sha256:43a4c7dfafd25f2a2c19d4ed6447f7e433a3e534a35e015472cd17921c194319"
        },
        "frameEvidenceFramesG0750Png": {
          "byteLength": 35739,
          "path": "validation/evidence/frames/g-0750.png",
          "sha256": "sha256:bfebccf25d35371168576136ac0c280832bd0a63fd3a0f22d9b8755a10c00f56"
        },
        "frameEvidenceFramesG1000Png": {
          "byteLength": 35140,
          "path": "validation/evidence/frames/g-1000.png",
          "sha256": "sha256:92a707b2f8cc53ec2e69dfc7e3d9b931b219a8f13abfd9d66e694358bb57afc4"
        },
        "frameEvidenceFramesO0125Png": {
          "byteLength": 31709,
          "path": "validation/evidence/frames/o-0125.png",
          "sha256": "sha256:7845020bb0635512eb0aa25ef7ffb2e71c59a6f8fe6d7596d6fafb609857b76d"
        },
        "frameEvidenceFramesO0250Png": {
          "byteLength": 31175,
          "path": "validation/evidence/frames/o-0250.png",
          "sha256": "sha256:6b9e29d6ac688da76eb68e79e0281af8be648147a9eb9c06f1a5a94257c3a8e2"
        },
        "frameEvidenceFramesO0500Png": {
          "byteLength": 30971,
          "path": "validation/evidence/frames/o-0500.png",
          "sha256": "sha256:87facea50413ac4dae342cd7062a947dd5eec6aeb16f2bf12ce414e3ff7b89ac"
        },
        "frameEvidenceFramesO0750Png": {
          "byteLength": 30972,
          "path": "validation/evidence/frames/o-0750.png",
          "sha256": "sha256:c1eae3a5885213905698b93097a16b9a4fb54b0e6b1705712d23da99d9e4407b"
        },
        "frameEvidenceFramesO1000Png": {
          "byteLength": 30414,
          "path": "validation/evidence/frames/o-1000.png",
          "sha256": "sha256:52b7e11bad40f53f41ae9da727ace472159bcec4750f825c73f14bfe76179f6d"
        },
        "frameEvidenceFramesY0125Png": {
          "byteLength": 32446,
          "path": "validation/evidence/frames/y-0125.png",
          "sha256": "sha256:6e1f7d0966aeb5deb31d06c1e754bce8f47e4f8f695182f521274a11eedca9ec"
        },
        "frameEvidenceFramesY0250Png": {
          "byteLength": 32283,
          "path": "validation/evidence/frames/y-0250.png",
          "sha256": "sha256:2bd71a12ff9e9b7a891f247c644d8ba64c4a521ccadebe5d06bbf3c38f1f471a"
        },
        "frameEvidenceFramesY0500Png": {
          "byteLength": 32073,
          "path": "validation/evidence/frames/y-0500.png",
          "sha256": "sha256:eb3bf7b96ef3e6967852fa54243271637cae690ad68e87f49992985d55a3beb3"
        },
        "frameEvidenceFramesY0750Png": {
          "byteLength": 31875,
          "path": "validation/evidence/frames/y-0750.png",
          "sha256": "sha256:ecda0a0d99d14731e215ae0418469194b9a8a3a2fde7aab288301121322c51b5"
        },
        "frameEvidenceFramesY1000Png": {
          "byteLength": 31489,
          "path": "validation/evidence/frames/y-1000.png",
          "sha256": "sha256:734f3b4ac128f3f3d47ea902dd316fda6c5c54bec0f2445eb7ba163ad5bb6cc1"
        },
        "frameEvidenceManifest": {
          "byteLength": 8220,
          "path": "validation/evidence/manifest.json",
          "sha256": "sha256:d37d2d24211658bf102006ce33b5d25ed6a6b88740d2083250484fb11da60c3d"
        },
        "frameEvidenceREADMEMd": {
          "byteLength": 1140,
          "path": "validation/evidence/README.md",
          "sha256": "sha256:69d33bde6afd03db4bb98b176f80e7dffd36885e7b7b22a46c360cdb24607939"
        },
        "guideAsset": {
          "byteLength": 172451,
          "path": "authoring/reference/guide-assets.js",
          "sha256": "sha256:b97ecd806cb66d37687111f2159934dc8915ec43ebcbb973e22c94a45dc6ae2a"
        },
        "guideAssetJson": {
          "byteLength": 171898,
          "path": "assets/alphabet-guides/generated/lowercase-guide-assets.v1.json",
          "sha256": "sha256:1fbc98259e8862e4dd330b49b435d4a3e267a4d8aa036dca99ecd692b3a51d21"
        },
        "originalSvgA": {
          "byteLength": 5484,
          "path": "assets/alphabet-guides/lowercase-svg/a.svg",
          "sha256": "sha256:e4f4095a352d41ca6d8d570a4ddeabe73b932bb086b712b807ceb6efd1d84e03"
        },
        "originalSvgB": {
          "byteLength": 5420,
          "path": "assets/alphabet-guides/lowercase-svg/b.svg",
          "sha256": "sha256:db868ade62882d24575674758b5f898f0e94f7e407dec80e342a37cecaad6d54"
        },
        "originalSvgC": {
          "byteLength": 4986,
          "path": "assets/alphabet-guides/lowercase-svg/c.svg",
          "sha256": "sha256:00cd47f75be5204e8452d85c1c157254e95bd26b93266beec9fa331d278990fa"
        },
        "originalSvgD": {
          "byteLength": 5394,
          "path": "assets/alphabet-guides/lowercase-svg/d.svg",
          "sha256": "sha256:e8674d318bc881c6092f0fbd1da4f804bdf08f66329c9b23c5bf85a24075993d"
        },
        "originalSvgE": {
          "byteLength": 5720,
          "path": "assets/alphabet-guides/lowercase-svg/e.svg",
          "sha256": "sha256:18b5313a3cb9d3143506e45716d2b2d247d9340626e5aa2bac37328992c64600"
        },
        "originalSvgF": {
          "byteLength": 4908,
          "path": "assets/alphabet-guides/lowercase-svg/f.svg",
          "sha256": "sha256:864589f19e4839269dd7d05da58e0842b201c6cd09fc904ad570f90593d7e3bf"
        },
        "originalSvgG": {
          "byteLength": 6682,
          "path": "assets/alphabet-guides/lowercase-svg/g.svg",
          "sha256": "sha256:710ef27c31a96b578b15f4ccf989a4930ebb5a1afea234aad8e44ef2551d4e38"
        },
        "originalSvgH": {
          "byteLength": 4727,
          "path": "assets/alphabet-guides/lowercase-svg/h.svg",
          "sha256": "sha256:2ca8122b04853f4bd86d5c88f2bbbe944219e3444d82f9b7f5865dcf6879a983"
        },
        "originalSvgI": {
          "byteLength": 4102,
          "path": "assets/alphabet-guides/lowercase-svg/i.svg",
          "sha256": "sha256:b6062063c5185efd495e76caad8f146f3d5d4977d9390af3f57c868185cf104b"
        },
        "originalSvgJ": {
          "byteLength": 4581,
          "path": "assets/alphabet-guides/lowercase-svg/j.svg",
          "sha256": "sha256:2d566bcef4bafe64bbecf5fa84185032fe8cedaec6472815e0a0fca5088ac8f6"
        },
        "originalSvgK": {
          "byteLength": 5436,
          "path": "assets/alphabet-guides/lowercase-svg/k.svg",
          "sha256": "sha256:f4cb3a00e0616a859d9445e040750161c935ea1c7017cf57423fac3268341bf3"
        },
        "originalSvgL": {
          "byteLength": 3115,
          "path": "assets/alphabet-guides/lowercase-svg/l.svg",
          "sha256": "sha256:cd82bff595d3c67d23f684f88eb52287dd531eec24ac36b59b18ef3d0e92ce52"
        },
        "originalSvgM": {
          "byteLength": 7457,
          "path": "assets/alphabet-guides/lowercase-svg/m.svg",
          "sha256": "sha256:e762e33d767709e9aef15b6f8e61bd4c398d3ee8733b4fee71f5458fb04ee756"
        },
        "originalSvgN": {
          "byteLength": 5139,
          "path": "assets/alphabet-guides/lowercase-svg/n.svg",
          "sha256": "sha256:a8859c03fc04107a0099400c388e966fd6d1e00cf9b8d611ac31d886707b801f"
        },
        "originalSvgO": {
          "byteLength": 3958,
          "path": "assets/alphabet-guides/lowercase-svg/o.svg",
          "sha256": "sha256:7050d03e7a09985cdb66b2d1f118fa09ec827d68896a9dacb35be00d527e6afb"
        },
        "originalSvgP": {
          "byteLength": 5442,
          "path": "assets/alphabet-guides/lowercase-svg/p.svg",
          "sha256": "sha256:898af6055b8b541fa27a6dcaaff349e202f3578300a751349c614042b0a44000"
        },
        "originalSvgQ": {
          "byteLength": 5566,
          "path": "assets/alphabet-guides/lowercase-svg/q.svg",
          "sha256": "sha256:90966e0c2f3520f25f8d85f6676eb886c6c24e2d3f4098760c866378b8f1c12c"
        },
        "originalSvgR": {
          "byteLength": 4742,
          "path": "assets/alphabet-guides/lowercase-svg/r.svg",
          "sha256": "sha256:b9a221edf56c8a773e548326fe98fdd74250c8b7455e8ff36c6196f21416ec57"
        },
        "originalSvgS": {
          "byteLength": 6143,
          "path": "assets/alphabet-guides/lowercase-svg/s.svg",
          "sha256": "sha256:7359baee9ac4e8c7ba16bb0a29d5bfcb6ccb58079a318c890b5c18c374b8f870"
        },
        "originalSvgT": {
          "byteLength": 4936,
          "path": "assets/alphabet-guides/lowercase-svg/t.svg",
          "sha256": "sha256:b760d35406516af7c0b939c348190a822c70fd25d7588724a721bab5188722c2"
        },
        "originalSvgU": {
          "byteLength": 5108,
          "path": "assets/alphabet-guides/lowercase-svg/u.svg",
          "sha256": "sha256:19396206adea7358bbf5f518a165e2da6e6783ddf01af6f22cb1ddb6cfa7e8f6"
        },
        "originalSvgV": {
          "byteLength": 3562,
          "path": "assets/alphabet-guides/lowercase-svg/v.svg",
          "sha256": "sha256:76f444d00347a3649f3c521b2419da3ae8b3bd1736d2291f05b8fc1430718e23"
        },
        "originalSvgW": {
          "byteLength": 6732,
          "path": "assets/alphabet-guides/lowercase-svg/w.svg",
          "sha256": "sha256:e123121aafffbacb7a1cb8b9b31812ee5520c2fbecdb5c24f3181993d525b62e"
        },
        "originalSvgX": {
          "byteLength": 4847,
          "path": "assets/alphabet-guides/lowercase-svg/x.svg",
          "sha256": "sha256:5ee59887c7771f1b8d20e08c345bcd93c9e1321cdae7c1311d28237b567edfb3"
        },
        "originalSvgY": {
          "byteLength": 3715,
          "path": "assets/alphabet-guides/lowercase-svg/y.svg",
          "sha256": "sha256:6d44a7be675a42e0f7b6ecbdddb192b555fc5177f83a23e6ee0c86887422f6d0"
        },
        "originalSvgZ": {
          "byteLength": 4958,
          "path": "assets/alphabet-guides/lowercase-svg/z.svg",
          "sha256": "sha256:9464874c3cc2ce5dec5c7e6e418b4b9de207e8418c878e79de12821a00a2ac1d"
        },
        "renderer": {
          "byteLength": 116083,
          "path": "renderer.js",
          "sha256": "sha256:63aa712788bf7cf2609cb2da5496afe0d6b682443373c86c9d17530e9fea6757"
        },
        "rendererReference": {
          "byteLength": 113577,
          "path": "authoring/reference/renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "runtime": {
          "byteLength": 712504,
          "path": "runtime.json",
          "sha256": "sha256:8782cb7d9c281db52516806f0d54f0456df140e06d02a082ed1e216803fd849c"
        },
        "sandboxReference": {
          "byteLength": 407568,
          "path": "authoring/reference/sandbox.html",
          "sha256": "sha256:5f44841b5286eed7d0108c990dd82ee8f03c1bda7252219cb9b210374c1c165d"
        },
        "sourceManifest": {
          "byteLength": 7922,
          "path": "assets/alphabet-guides/manifests/lowercase-source-manifest.v1.json",
          "sha256": "sha256:4b2502cad013b9e5fb65c0a14905915c0d9ed3ab92c118bb4cd7c6a1151f4b2c"
        },
        "validationReport": {
          "byteLength": 45325,
          "path": "validation/frame-report.json",
          "sha256": "sha256:2a7279b93429a20073dd4271207986012170598697237a2c26332162119e18ed"
        },
        "visualValidation": {
          "byteLength": 24037,
          "path": "validation/visual-controls.json",
          "sha256": "sha256:fb99073e303230dac159ecd1bf74b9f4b286ba8e53bfb4a246b36f40dc27bbfd"
        },
        "wordLayoutPolicy": {
          "byteLength": 317,
          "path": "word-layout-policy.json",
          "sha256": "sha256:e2603f8d22076c8297c9af33692e07128185d659d5ead2d7dcc1f9ff121abcba"
        }
      },
      "glyphs": "abcdefghijklmnopqrstuvwxyz",
      "playbackContract": "authoringStrokePlayback",
      "profiles": {
        "aiRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ],
        "audit": [
          "approvalBinding",
          "approvalReferenceManifest",
          "approvalState",
          "cutModelReference",
          "frameEvidenceFramesE0125Png",
          "frameEvidenceFramesE0250Png",
          "frameEvidenceFramesE0500Png",
          "frameEvidenceFramesE0750Png",
          "frameEvidenceFramesE1000Png",
          "frameEvidenceFramesG0125Png",
          "frameEvidenceFramesG0250Png",
          "frameEvidenceFramesG0500Png",
          "frameEvidenceFramesG0750Png",
          "frameEvidenceFramesG1000Png",
          "frameEvidenceFramesO0125Png",
          "frameEvidenceFramesO0250Png",
          "frameEvidenceFramesO0500Png",
          "frameEvidenceFramesO0750Png",
          "frameEvidenceFramesO1000Png",
          "frameEvidenceFramesY0125Png",
          "frameEvidenceFramesY0250Png",
          "frameEvidenceFramesY0500Png",
          "frameEvidenceFramesY0750Png",
          "frameEvidenceFramesY1000Png",
          "frameEvidenceManifest",
          "frameEvidenceREADMEMd",
          "guideAsset",
          "guideAssetJson",
          "originalSvgA",
          "originalSvgB",
          "originalSvgC",
          "originalSvgD",
          "originalSvgE",
          "originalSvgF",
          "originalSvgG",
          "originalSvgH",
          "originalSvgI",
          "originalSvgJ",
          "originalSvgK",
          "originalSvgL",
          "originalSvgM",
          "originalSvgN",
          "originalSvgO",
          "originalSvgP",
          "originalSvgQ",
          "originalSvgR",
          "originalSvgS",
          "originalSvgT",
          "originalSvgU",
          "originalSvgV",
          "originalSvgW",
          "originalSvgX",
          "originalSvgY",
          "originalSvgZ",
          "renderer",
          "rendererReference",
          "runtime",
          "sandboxReference",
          "sourceManifest",
          "validationReport",
          "visualValidation",
          "wordLayoutPolicy"
        ],
        "webRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ]
      },
      "projectBindingVersion": "alphabet.authoring_project_binding.v2",
      "releaseId": "lowercase-bundle-981d633d17a3bc31",
      "rendererVersion": "alphabet.authoring_playback_engine.v4",
      "runtimeVersion": "alphabet.authoring_runtime.v2",
      "validation": {
        "comparison": "green-fill-mask-pixel-exact",
        "frameCount": 130,
        "status": "passed"
      },
      "version": "alphabet.authoring_release_bundle.v1"
    },
    "manifestByteLength": 15416,
    "manifestSha256": "sha256:dcf97b894246de3bdbb1003cabc766081c7f4f30af41c26379ad98b125dd8a65"
  },
  {
    "manifest": {
      "alphabetCase": "uppercase",
      "bundleContentHash": "sha256:b13c500f2bf340e98c6c3e012eb35d20a2b9a9bbfcc0c1da6ba854e1c3c9c89a",
      "files": {
        "approvalBinding": {
          "byteLength": 630,
          "path": "validation/approval-binding.json",
          "sha256": "sha256:bf7f09ced768c0b6d42e723b51a9da79d5194fc1ad128a859fd194125b4709e7"
        },
        "approvalReferenceManifest": {
          "byteLength": 1130,
          "path": "validation/approval-reference.json",
          "sha256": "sha256:25cd2f0b3540a2d7fdb29cebde73f66088145cd6812b4d99e5c4c87d5f03cdf6"
        },
        "approvalState": {
          "byteLength": 475355,
          "path": "approval-state.json",
          "sha256": "sha256:34efa0e66239f05b41d6dfe33eb93a34378acc61be312f81e42abcb3ee5be597"
        },
        "cutModelReference": {
          "byteLength": 44913,
          "path": "authoring/reference/cut-model.js",
          "sha256": "sha256:cf8847105dfbbd3f69163b5ff5535dafd448e95e3346afbfab5c4944b415f108"
        },
        "frameEvidenceFramesA0125Png": {
          "byteLength": 36223,
          "path": "validation/evidence/frames/A-0125.png",
          "sha256": "sha256:2c67ab33829ee1f6efdd85c24717c567655a9dad2643fb6b0c8473412aef9313"
        },
        "frameEvidenceFramesA0250Png": {
          "byteLength": 36030,
          "path": "validation/evidence/frames/A-0250.png",
          "sha256": "sha256:ffd836d42cc5e0a6444d2aaecfa1a99e08f0916526d7a35de13efed1628af695"
        },
        "frameEvidenceFramesA0500Png": {
          "byteLength": 35260,
          "path": "validation/evidence/frames/A-0500.png",
          "sha256": "sha256:669db62c04c45c62615cbdcaa2517d247f8206046db6c41e2a99bea68fde84f3"
        },
        "frameEvidenceFramesA0750Png": {
          "byteLength": 34531,
          "path": "validation/evidence/frames/A-0750.png",
          "sha256": "sha256:63f19932bb852c399469b85e670c9d7df9e53fb3b321aead24c4b323dd880c17"
        },
        "frameEvidenceFramesA1000Png": {
          "byteLength": 34202,
          "path": "validation/evidence/frames/A-1000.png",
          "sha256": "sha256:5f60d5611b0ea6ecf6f7b32cced07b0d310185e42e73c2d4fe9714ea62b959f2"
        },
        "frameEvidenceFramesB0125Png": {
          "byteLength": 32700,
          "path": "validation/evidence/frames/B-0125.png",
          "sha256": "sha256:3e9e04bca37e03ca733a5b69a3e600341f81f1655d29cf6c6c54313c436d7bd4"
        },
        "frameEvidenceFramesB0250Png": {
          "byteLength": 32171,
          "path": "validation/evidence/frames/B-0250.png",
          "sha256": "sha256:4ebdf6a964fdd8e8b827c9ef4a63f6ab3320eae56f55d79c64fce468e0de002e"
        },
        "frameEvidenceFramesB0500Png": {
          "byteLength": 31581,
          "path": "validation/evidence/frames/B-0500.png",
          "sha256": "sha256:40a2825fab3de567d3798d7838828e241472f41d4c32ad1af9dcf422c22ecb08"
        },
        "frameEvidenceFramesB0750Png": {
          "byteLength": 31164,
          "path": "validation/evidence/frames/B-0750.png",
          "sha256": "sha256:be4450d0005e999943bb5c4afab68f5796faf8d1b750eafee3e4498ba79adca1"
        },
        "frameEvidenceFramesB1000Png": {
          "byteLength": 30975,
          "path": "validation/evidence/frames/B-1000.png",
          "sha256": "sha256:458dbfb1d5538cca2f34228449d42d524fd674c0f07e0ece0148244dbe0420bd"
        },
        "frameEvidenceFramesG0125Png": {
          "byteLength": 39285,
          "path": "validation/evidence/frames/G-0125.png",
          "sha256": "sha256:2889a399d879a6b6d5f93e35d6856045b2456a8798a4adade90304eca6f7081f"
        },
        "frameEvidenceFramesG0250Png": {
          "byteLength": 39287,
          "path": "validation/evidence/frames/G-0250.png",
          "sha256": "sha256:41fc19febc35011e063fe2691762e7270a124fa43db1014341e671e7c9c412e7"
        },
        "frameEvidenceFramesG0500Png": {
          "byteLength": 39517,
          "path": "validation/evidence/frames/G-0500.png",
          "sha256": "sha256:c305c02377712ea88a14c4a749463d446b1d4c5f6a90d2e3ac61f9dc80eb78f7"
        },
        "frameEvidenceFramesG0750Png": {
          "byteLength": 39574,
          "path": "validation/evidence/frames/G-0750.png",
          "sha256": "sha256:9a72e5948d7765e2d83de1e4aadeb078118302e30297f2e9e3e34beb1e0c3055"
        },
        "frameEvidenceFramesG1000Png": {
          "byteLength": 39253,
          "path": "validation/evidence/frames/G-1000.png",
          "sha256": "sha256:53173c098a8274f1f7e54eccfb322a62c4c9fd124a891a29148ad0df66e5099b"
        },
        "frameEvidenceFramesO0125Png": {
          "byteLength": 42910,
          "path": "validation/evidence/frames/O-0125.png",
          "sha256": "sha256:7e1a075d13c9ff71fe464f0e36c0d5a266936b2f85f27a3246a733b055a9a3ea"
        },
        "frameEvidenceFramesO0250Png": {
          "byteLength": 42507,
          "path": "validation/evidence/frames/O-0250.png",
          "sha256": "sha256:e7ef5917044e7af493c4576589c6619b3165d94e7c0ad196cfba2bf9499c82c5"
        },
        "frameEvidenceFramesO0500Png": {
          "byteLength": 41972,
          "path": "validation/evidence/frames/O-0500.png",
          "sha256": "sha256:3da886a8542038f2a341b00afaf4b857037739f952ec46ec3a0b855d80dd3c0e"
        },
        "frameEvidenceFramesO0750Png": {
          "byteLength": 41056,
          "path": "validation/evidence/frames/O-0750.png",
          "sha256": "sha256:e18269b1af6ec1fa0ec5e91d78126f38b6a20ef27d46c2fb05047c3369bfdc88"
        },
        "frameEvidenceFramesO1000Png": {
          "byteLength": 40288,
          "path": "validation/evidence/frames/O-1000.png",
          "sha256": "sha256:506bd335335f2b8ab677bc8f720729a68e0c04471dae6b623adc1a7d53acc9ce"
        },
        "frameEvidenceManifest": {
          "byteLength": 8220,
          "path": "validation/evidence/manifest.json",
          "sha256": "sha256:7f5a1966fbd4dcd5a4be83f140210cf6f89f5132c65c936415162efccded6a41"
        },
        "frameEvidenceREADMEMd": {
          "byteLength": 1140,
          "path": "validation/evidence/README.md",
          "sha256": "sha256:b88e5702fdc1a65d53aa5c85025e67372b0db6395a345bfd8ab77eb49c504ee8"
        },
        "guideAsset": {
          "byteLength": 168593,
          "path": "authoring/reference/guide-assets.js",
          "sha256": "sha256:79f034d7d706788689321b4470339bb469dfeb54131374a17bbe4f18d2a89bf7"
        },
        "guideAssetJson": {
          "byteLength": 167980,
          "path": "assets/alphabet-guides/generated/uppercase-guide-assets.v1.json",
          "sha256": "sha256:3c026a449c1ce4f599e1a4c0cc9c707e21d2fbd3b3efc03acca482c95cea6d6b"
        },
        "originalSvgA": {
          "byteLength": 4921,
          "path": "assets/alphabet-guides/uppercase-svg/A.svg",
          "sha256": "sha256:ea297a67cc3b3ab43d9f1de36ce564b35bdb946edd3c23a19e7c1bbf4c77e01a"
        },
        "originalSvgB": {
          "byteLength": 6727,
          "path": "assets/alphabet-guides/uppercase-svg/B.svg",
          "sha256": "sha256:020c01bdd098be84214c01fd8233735dadac0b82c10bb27e12af96e2705aa7bd"
        },
        "originalSvgC": {
          "byteLength": 5622,
          "path": "assets/alphabet-guides/uppercase-svg/C.svg",
          "sha256": "sha256:bd4d565b0540f80a1b8fb567eede0c2a65834b88bf5dbc1ade8d81767815a668"
        },
        "originalSvgD": {
          "byteLength": 4299,
          "path": "assets/alphabet-guides/uppercase-svg/D.svg",
          "sha256": "sha256:e3f792f3d52c9daf7c7fb74252029c4dd702a2c95cca3462d0fa402d8866f367"
        },
        "originalSvgE": {
          "byteLength": 6086,
          "path": "assets/alphabet-guides/uppercase-svg/E.svg",
          "sha256": "sha256:a0c7ce87582276688a0ce64117d24957e38922f0a7cd821f08b5254acadfd673"
        },
        "originalSvgF": {
          "byteLength": 5004,
          "path": "assets/alphabet-guides/uppercase-svg/F.svg",
          "sha256": "sha256:dc1949ae89fa35214140b324a934bac22a4bb5df2e89d320ec2834d3aac84e9b"
        },
        "originalSvgG": {
          "byteLength": 6401,
          "path": "assets/alphabet-guides/uppercase-svg/G.svg",
          "sha256": "sha256:75ab3bf243d6fc7b32958a5d56c33acb6c31f239e5b48df4b2e3d673240be55b"
        },
        "originalSvgH": {
          "byteLength": 5354,
          "path": "assets/alphabet-guides/uppercase-svg/H.svg",
          "sha256": "sha256:74ab6ea8ece6a55d9c8e7089d194a9efc160a08d6857426ea56613b9aeb92b8f"
        },
        "originalSvgI": {
          "byteLength": 2396,
          "path": "assets/alphabet-guides/uppercase-svg/I.svg",
          "sha256": "sha256:49c3149b8803f32af9dc93c6c1e33b936680fa4742153732faf35df693b7bf92"
        },
        "originalSvgJ": {
          "byteLength": 3986,
          "path": "assets/alphabet-guides/uppercase-svg/J.svg",
          "sha256": "sha256:0e6974b8385d3489286c795b291502862e95f4e2e859921bde67d4faa20a9e66"
        },
        "originalSvgK": {
          "byteLength": 5440,
          "path": "assets/alphabet-guides/uppercase-svg/K.svg",
          "sha256": "sha256:9d945e355be95adc42729315bec571a46137436dc2c72ac23ae6925940b21bb5"
        },
        "originalSvgL": {
          "byteLength": 3502,
          "path": "assets/alphabet-guides/uppercase-svg/L.svg",
          "sha256": "sha256:229a54c80555d24d1783ba55cb3aaedb7e088252c0ed4d415165af239bc861ae"
        },
        "originalSvgM": {
          "byteLength": 6741,
          "path": "assets/alphabet-guides/uppercase-svg/M.svg",
          "sha256": "sha256:7148abaf0eb7f8eae1a47554748b94125c75680b11fdfb4db08466f882daf18f"
        },
        "originalSvgN": {
          "byteLength": 5234,
          "path": "assets/alphabet-guides/uppercase-svg/N.svg",
          "sha256": "sha256:fc06c3146b920839448aa312f23669f5791baca91b4ae7dc9a7564f781062072"
        },
        "originalSvgO": {
          "byteLength": 4450,
          "path": "assets/alphabet-guides/uppercase-svg/O.svg",
          "sha256": "sha256:161660cfbe27b35cf33cc8e909d322861eb210359ab1052c0a8797b88d55b585"
        },
        "originalSvgP": {
          "byteLength": 4450,
          "path": "assets/alphabet-guides/uppercase-svg/P.svg",
          "sha256": "sha256:263665875c3314203849c125b7afd8fdeb9822ba72d3ccec06bad3aa82151bc4"
        },
        "originalSvgQ": {
          "byteLength": 5947,
          "path": "assets/alphabet-guides/uppercase-svg/Q.svg",
          "sha256": "sha256:b4e95088ad6a3944a8e857ba9bc80a0703f59d4eef09620d9753fd670296e36b"
        },
        "originalSvgR": {
          "byteLength": 6064,
          "path": "assets/alphabet-guides/uppercase-svg/R.svg",
          "sha256": "sha256:474038d3bdba9606570ad03332023102ee6110998cf91b66c5707a742d882eb4"
        },
        "originalSvgS": {
          "byteLength": 6603,
          "path": "assets/alphabet-guides/uppercase-svg/S.svg",
          "sha256": "sha256:bf85858b4148f58d2d136b09f19ee280e7ef2e40f9a2445ef6a589fe73647ca1"
        },
        "originalSvgT": {
          "byteLength": 3758,
          "path": "assets/alphabet-guides/uppercase-svg/T.svg",
          "sha256": "sha256:17ee832c68f3a57be468a354cf88186fde8a39e58005c3dd99f546b2dddc3bd4"
        },
        "originalSvgU": {
          "byteLength": 3821,
          "path": "assets/alphabet-guides/uppercase-svg/U.svg",
          "sha256": "sha256:e19256a3be8997f6fbdcefea3b0f8d7bffec1608549d71325074d85594048485"
        },
        "originalSvgV": {
          "byteLength": 3616,
          "path": "assets/alphabet-guides/uppercase-svg/V.svg",
          "sha256": "sha256:a0b188444bddb8faa3b3638ad784b8f41f664120ed03991669da70c62c601630"
        },
        "originalSvgW": {
          "byteLength": 6930,
          "path": "assets/alphabet-guides/uppercase-svg/W.svg",
          "sha256": "sha256:e0bca49d0405372380e200f51335527608c8986efc760618c4f5c132410b0cd8"
        },
        "originalSvgX": {
          "byteLength": 4546,
          "path": "assets/alphabet-guides/uppercase-svg/X.svg",
          "sha256": "sha256:01005f82f06890974c7057f0984cc7cb98001a305ad987530d1e63bc58ed34ad"
        },
        "originalSvgY": {
          "byteLength": 4893,
          "path": "assets/alphabet-guides/uppercase-svg/Y.svg",
          "sha256": "sha256:eeda66413eb6002b22e23eb5f2b772a4e1daa2a9217bc0ffb27e33abf9915fb9"
        },
        "originalSvgZ": {
          "byteLength": 5049,
          "path": "assets/alphabet-guides/uppercase-svg/Z.svg",
          "sha256": "sha256:eeb12914e873a3992ee8f99bf5d80cfedd3a9a015e4a0680b80723e28cdcf949"
        },
        "renderer": {
          "byteLength": 116083,
          "path": "renderer.js",
          "sha256": "sha256:63aa712788bf7cf2609cb2da5496afe0d6b682443373c86c9d17530e9fea6757"
        },
        "rendererReference": {
          "byteLength": 113577,
          "path": "authoring/reference/renderer.js",
          "sha256": "sha256:9920befe8fa59c4535e0707976dd53afa5891163e66eb976910fff635d47b379"
        },
        "runtime": {
          "byteLength": 985989,
          "path": "runtime.json",
          "sha256": "sha256:3ff813f8d4cbfa3beea83035553fc25f92969c8912051b5b35cb84b4771628ae"
        },
        "sandboxReference": {
          "byteLength": 407568,
          "path": "authoring/reference/sandbox.html",
          "sha256": "sha256:5f44841b5286eed7d0108c990dd82ee8f03c1bda7252219cb9b210374c1c165d"
        },
        "sourceManifest": {
          "byteLength": 7952,
          "path": "assets/alphabet-guides/manifests/uppercase-source-manifest.v1.json",
          "sha256": "sha256:733cc740649e740ffaaa29cf852b01d63acc6c3080e658cd397aed6a65513b18"
        },
        "validationReport": {
          "byteLength": 45370,
          "path": "validation/frame-report.json",
          "sha256": "sha256:0ac423adc0569d8f74b52f944cebbfbccae8ed2de1b966241bb894fb8f471621"
        },
        "visualValidation": {
          "byteLength": 25129,
          "path": "validation/visual-controls.json",
          "sha256": "sha256:7e39dc5a60108d7ceb3d2a582226e52daff544be8313d9424084b4018c932986"
        },
        "wordLayoutPolicy": {
          "byteLength": 317,
          "path": "word-layout-policy.json",
          "sha256": "sha256:e2603f8d22076c8297c9af33692e07128185d659d5ead2d7dcc1f9ff121abcba"
        }
      },
      "glyphs": "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      "playbackContract": "authoringStrokePlayback",
      "profiles": {
        "aiRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ],
        "audit": [
          "approvalBinding",
          "approvalReferenceManifest",
          "approvalState",
          "cutModelReference",
          "frameEvidenceFramesA0125Png",
          "frameEvidenceFramesA0250Png",
          "frameEvidenceFramesA0500Png",
          "frameEvidenceFramesA0750Png",
          "frameEvidenceFramesA1000Png",
          "frameEvidenceFramesB0125Png",
          "frameEvidenceFramesB0250Png",
          "frameEvidenceFramesB0500Png",
          "frameEvidenceFramesB0750Png",
          "frameEvidenceFramesB1000Png",
          "frameEvidenceFramesG0125Png",
          "frameEvidenceFramesG0250Png",
          "frameEvidenceFramesG0500Png",
          "frameEvidenceFramesG0750Png",
          "frameEvidenceFramesG1000Png",
          "frameEvidenceFramesO0125Png",
          "frameEvidenceFramesO0250Png",
          "frameEvidenceFramesO0500Png",
          "frameEvidenceFramesO0750Png",
          "frameEvidenceFramesO1000Png",
          "frameEvidenceManifest",
          "frameEvidenceREADMEMd",
          "guideAsset",
          "guideAssetJson",
          "originalSvgA",
          "originalSvgB",
          "originalSvgC",
          "originalSvgD",
          "originalSvgE",
          "originalSvgF",
          "originalSvgG",
          "originalSvgH",
          "originalSvgI",
          "originalSvgJ",
          "originalSvgK",
          "originalSvgL",
          "originalSvgM",
          "originalSvgN",
          "originalSvgO",
          "originalSvgP",
          "originalSvgQ",
          "originalSvgR",
          "originalSvgS",
          "originalSvgT",
          "originalSvgU",
          "originalSvgV",
          "originalSvgW",
          "originalSvgX",
          "originalSvgY",
          "originalSvgZ",
          "renderer",
          "rendererReference",
          "runtime",
          "sandboxReference",
          "sourceManifest",
          "validationReport",
          "visualValidation",
          "wordLayoutPolicy"
        ],
        "webRuntime": [
          "renderer",
          "runtime",
          "wordLayoutPolicy"
        ]
      },
      "projectBindingVersion": "alphabet.authoring_project_binding.v2",
      "releaseId": "uppercase-bundle-b13c500f2bf340e9",
      "rendererVersion": "alphabet.authoring_playback_engine.v4",
      "runtimeVersion": "alphabet.authoring_runtime.v2",
      "validation": {
        "comparison": "green-fill-mask-pixel-exact",
        "frameCount": 130,
        "status": "passed"
      },
      "version": "alphabet.authoring_release_bundle.v1"
    },
    "manifestByteLength": 15416,
    "manifestSha256": "sha256:8af09b9101e9a676fc80c0495c643667295091373ba6be39d4c7384676915ee4"
  }
];

export function pinnedWritingBundle(hash: string | undefined): PinnedWritingBundle | undefined {
  return PINNED.find(entry => entry.manifest.bundleContentHash === hash);
}

export function assertPinnedWritingGuideRelease(
  release: ApprovedWritingGuideRelease,
  claimedManifest: unknown,
): PinnedWritingBundle {
  const pin = pinnedWritingBundle(release.bundleContentHash);
  if (!pin || !sameCanonicalJson(claimedManifest, pin.manifest)) {
    throw Error('현재 프로젝트의 따라쓰기 번들이 승인된 회사 릴리스와 다릅니다.');
  }
  const expected = pin.manifest;
  const files = expected.files as Record<string, {path: string; sha256: string}>;
  const root = `/agent-workflow/alphabet-authoring/bundles/${release.bundleContentHash?.replace(':', '-')}`;
  if (release.releaseId !== expected.releaseId ||
      release.alphabetCase !== expected.alphabetCase ||
      release.runtimeVersion !== expected.runtimeVersion ||
      release.rendererVersion !== expected.rendererVersion ||
      release.playbackContract !== expected.playbackContract ||
      release.bundleManifestAssetPath !== `${root}/manifest.v1.json` ||
      release.runtimeAssetPath !== `${root}/${files.runtime.path}` ||
      release.runtimeAssetSourceHash !== files.runtime.sha256 ||
      release.rendererAssetPath !== `${root}/${files.renderer.path}` ||
      release.rendererSourceHash !== files.renderer.sha256 ||
      release.wordLayoutPolicyAssetPath !== `${root}/${files.wordLayoutPolicy.path}` ||
      release.wordLayoutPolicySourceHash !== files.wordLayoutPolicy.sha256) {
    throw Error('현재 프로젝트의 따라쓰기 번들 출처가 승인본과 다릅니다.');
  }
  return pin;
}
